module.exports = __webpack_public_path__ + "static/media/03_blanco.b97b9889.svg";